import * as React from 'react';

const DocumentIcon = ({ className, ...props }) => {
    return (
        <svg className={className} {...props} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M14 2.00024H6.00001C5.46957 2.00024 4.96087 2.21096 4.58579 2.58603C4.21072 2.9611 4.00001 3.46981 4.00001 4.00024V20.0002C4.00001 20.5307 4.21072 21.0394 4.58579 21.4145C4.96087 21.7895 5.46957 22.0002 6.00001 22.0002H18C18.5304 22.0002 19.0391 21.7895 19.4142 21.4145C19.7893 21.0394 20 20.5307 20 20.0002V8.00024L14 2.00024Z"
                stroke="#FFFFFF"
                strokeWidth="1.7"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M14 2.00024V8.00024H20" stroke="#FFFFFF" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 12.9998H8" stroke="#FFFFFF" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M16 17.0002H8" stroke="#FFFFFF" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M10 9H9H8" stroke="#FFFFFF" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );
};

export default DocumentIcon;
